import { render, staticRenderFns } from "./CloseOutlinedGray.vue?vue&type=template&id=76d56648"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('76d56648')) {
      api.createRecord('76d56648', component.options)
    } else {
      api.reload('76d56648', component.options)
    }
    module.hot.accept("./CloseOutlinedGray.vue?vue&type=template&id=76d56648", function () {
      api.rerender('76d56648', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/CloseOutlinedGray.vue"
export default component.exports